import React, { useState, useEffect } from 'react';
import { useTheme } from '../../contexts/ThemeContext';

interface TextFilterProps {
  label: string;
  value: string;
  onFilterChange: (value: string) => void;
  placeholder?: string;
}

const TextFilter: React.FC<TextFilterProps> = ({
  label,
  value,
  onFilterChange,
  placeholder = 'Type to filter...',
}) => {
  const { colors } = useTheme();
  const [inputValue, setInputValue] = useState<string>(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleChange = (newValue: string) => {
    setInputValue(newValue);
    onFilterChange(newValue);
  };

  const handleClear = () => {
    setInputValue('');
    onFilterChange('');
  };

  return (
    <div className="relative">
      <label className={`block text-xs font-medium ${colors.textSecondary} mb-2`}>{label}</label>
      <div className="relative">
        <input
          type="text"
          value={inputValue}
          onChange={(e) => handleChange(e.target.value)}
          placeholder={placeholder}
          className={`w-full px-3 py-2 text-sm border ${colors.border} rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 ${colors.surface} ${colors.text} placeholder-${colors.textMuted}`}
        />
        {inputValue && (
          <button
            type="button"
            onClick={handleClear}
            className={`absolute right-2 top-1/2 transform -translate-y-1/2 p-1 ${colors.textMuted} hover:${colors.textSecondary} transition-colors`}
            title="Clear"
          >
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

export default TextFilter;

